import { InputSettings, NotificationSettings, TooltipSettings, ContextMenuSettings } from "@app/shared/models/portal-settings.model";
import { ThemeSettings } from "@app/shared/models/user-settings.model";

export const TABLE_SIZE_OPTIONS = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 75, 100];

export interface SystemSettings {
  clientCode: string;
  name: string;
  isDisabled: boolean;
  portalDisabledMessage: string;
  loginTheme: string;
  largeLogoPath: string;
  smallLogoPath: string;
  logoApplyContrast: boolean;
  localeSettings: LocaleSettings;
  backgroundImagePath: string;
  passwordSettings: PasswordSettings;
  themeSettings: ThemeSettings;
  inputSettings: InputSettings;
  notificationSettings: NotificationSettings;
  tooltipSettings: TooltipSettings;
  contextMenuSettings: ContextMenuSettings;
  reportPlusSettings: ReportPlusSettings;
  secondAuthFactorSettings: TwoFactorSettings;
  timeoutSettings: TimeoutSettings;
}

export interface Language {
  name: string;
  value: string;
}

export interface DateFormat {
  name: string;
  value: string;
}

export interface Logo {
  name: string;
  smallValue: string;
  fullValue: string;
}

export interface PasswordSettings {
  passEnableLowerCase: boolean;
  passEnableUpperCase: boolean;
  passEnableDigit: boolean;
  passEnableSpecialChar: boolean;
  passMinLength: number;
  passMaxLength: number;
  passNoRepeatingCharacters: boolean;
}

export interface LocaleSettings {
  language: string;
  dateFormat: string;
  timestampFormat: string;
}

export interface Imagepaths {
  smallLogoPath: string;
  largeLogoPath: string;
  backgroundLogoPath?: string;
}

export interface ReportPlusSettings {
  reportPlusImageWidth: number;
  reportPlusImageHeight: number;
  reportPlusImageMaxSize: number;
}

export interface TwoFactorSettings {
  enforce2FA: boolean;
  type2Fa: number;
}

export interface TimeoutSettings {
  isTimeoutEnabled: boolean;
  timeoutMinutes: number;
  timeoutCountDownSeconds: number;
}
